<template>
    <section class="min-h-screen w-full flex flex-col bg-gradient-to-br from-gray-100 to-blue-50">
        <div class="container mx-auto">
            <div class="px-4 sm:px-8 flex flex-col w-full pb-4 sm:pb-8 mt-4 sm:mt-8">
                <div class="mb-4">
                    <bread-crumb :items="breadCrumbItems"></bread-crumb>
                </div>

                <div
                    class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 sm:gap-8">
                    <tile v-for="(item, index) in filteredMenu" :key="index" :item="item"></tile>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Tile from "../../components/shared/Tile.vue";
import BreadCrumb from "../../components/shared/BreadCrumb.vue";
import { ADPOLY_CAMPUSES } from "./config";

export default {
    name: "adpoly-index",
    components: {
        Tile,
        BreadCrumb,
    },
    data() {
        return {
            breadCrumbItems: [
                { label: "Dashboard", path: "/dashboard" },
                { label: "ADPOLY" },
            ],
            campusImages: {
                "abu-dhabi": require("../../assets/images/icons/img1.png"),
                "al-ain": require("../../assets/images/icons/img2.png"),
            },
        };
    },
    computed: {
        role() {
            return this.$store.getters.role;
        },
        permissions() {
            return this.$store.getters.permissions;
        },
        menu() {
            const images = this.campusImages;
            return Object.keys(ADPOLY_CAMPUSES).map(function (key, index) {
                const campus = ADPOLY_CAMPUSES[key];
                return {
                    id: index + 1,
                    isActive: true,
                    isImage: true,
                    path: "/adpoly/" + campus.key,
                    title: campus.title,
                    icon: "",
                    image: images[campus.key] || images["abu-dhabi"],
                    isNotificationNumber: 0,
                    popOverContent: "",
                    showPopOver: false,
                    role: ["superadmin", "admin", "faculty", "HOD", "Viewer", "careercounselor"],
                    permission: campus.permission,
                };
            });
        },
        filteredMenu() {
            return this.menu.filter((item) => {
                const hasRole = item.role.includes(this.role);

                const hasPermission =
                    this.role === "superadmin" ||
                    !item.permission ||
                    this.permissions.includes(item.permission);

                return hasRole && hasPermission;
            });
        },
    },
};
</script>
